import authStore from "../../store/auth-store.jsx";

function getJsonData(url) {
    return new Promise((resolve, reject) => {
        var token = authStore.getFormatedToken();
        fetch(url, {
            method: "GET",
            headers: {
                auth: token
            },
        }).then((res) => {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => resolve(data));
                        break;
                    default:
                        res.text().then(data => resolve(data));
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => reject(data));
                        break;
                    default:
                        res.text().then(data => reject(data));
                }
            }
        });
    });

}

function postJson(url, data) {
    return new Promise((resolve, reject) => {
        var token = authStore.getFormatedToken();
        fetch(url, { method: "POST", headers: { "Content-Type": "application/json", auth: token }, body: JSON.stringify(data) }).then((res) => {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => resolve(data));
                        break;
                    case "application/pdf":
                        res.blob().then(data => resolve(data));
                        break;
                    default:
                        res.text().then(data => resolve(data));
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => reject(data));
                        break;
                    default:
                        res.text().then(data => reject(data));
                }
            }
        });
    });
}

function post(url, data) {
    return new Promise((resolve, reject) => {
        var token = authStore.getFormatedToken();
        fetch(url, { method: "POST", headers: { "content-type": "application/x-www-form-urlencoded", auth: token }, body: objectToKeyValue(data) }).then((res) => {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => resolve(data));
                        break;
                    default:
                        res.text().then(data => resolve(data));
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => reject(data));
                        break;
                    default:
                        res.text().then(data => reject(data));
                }
            }
        });
    });
}






function objectToKeyValue(obj) {
    var str = "";

    for (var prop in obj) {
        if (obj[prop] !== null && obj[prop] !== undefined) {
            str += prop + "=" + obj[prop].toString() + "&";
        }
    }
    return str.substring(0, str.lastIndexOf("&"));
}

function putJson(url, data) {
    return new Promise((resolve, reject) => {
        var token = authStore.getFormatedToken();
        fetch(url, { method: "PUT", headers: { "Content-Type": "application/json", auth: token }, body: JSON.stringify(data) }).then((res) => {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => resolve(data));
                        break;
                    default:
                        res.text().then(data => resolve(data));
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => reject(data));
                        break;
                    default:
                        res.text().then(data => reject(data));
                }
            }
        });
    });
}


function deleteData(url) {
    return new Promise((resolve, reject) => {
        var token = authStore.getFormatedToken();

        fetch(url, {
            method: "DELETE",
            headers: {
                auth: token
            },
        }).then((res) => {
            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => resolve(data));
                        break;
                    default:
                        res.text().then(data => resolve(data));
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => reject(data));
                        break;
                    default:
                        res.text().then(data => reject(data));
                }
            }
        });
    });

}

function deletePostData(url, data) {
    return new Promise((resolve, reject) => {
        var token = authStore.getFormatedToken();
        fetch(url, { method: "DELETE", headers: { "content-type": "application/x-www-form-urlencoded", auth: token }, body: objectToKeyValue(data) }).then((res) => {

            var contentType = res.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                contentType = "application/json; charset=utf-8";
            }

            if (res.ok) {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => resolve(data));
                        break;
                    default:
                        res.text().then(data => resolve(data));
                }
            } else {
                switch (contentType) {
                    case "application/json; charset=utf-8":
                        res.json().then(data => reject(data));
                        break;
                    default:
                        res.text().then(data => reject(data));
                }
            }
        });
    });

}


const rq = {
    getJsonData,
    postJson,
    post,
    putJson,
    deleteData,
    deletePostData
};

export default rq;



// WEBPACK FOOTER //
// ./src/jsx/components/utility/rq.js